import { Drawer, Icon, Stack, Title, useTheme } from "@introist/react-foundation/v2";
import { DrawerHeader } from "../../../../foundation/templates/Drawer/DrawerHeader";
import { api } from "../../../../services/rpc/RpcProvider";
import { ListView } from "../../../../foundation";
import { ListRow } from "../../../../components/organisms";
import { DataSourceIcon } from "../../components/DataSourceIcon";
import { formatDate } from "../../../../utils/DatesUtils";
import { DateFormats } from "../../../../utils/dates";
import { CappedTitle } from "../../../../components/molecules";

export const EmployeeSyncLogDrawer = ({
  employeeId,
  open,
  onClose
}: {
  employeeId?: string;
  open: boolean;
  onClose: () => unknown;
}) => {
  const { theme } = useTheme();
  const { data: logs } = api.datasources.employeeSyncLogs.useQuery(
    { employeeId: employeeId ?? "" },
    {
      enabled: Boolean(employeeId)
    }
  );

  return (
    <Drawer open={open} onClose={onClose} width="540px">
      <Stack vertical style={{ padding: "var(--spacing-large)" }}>
        <DrawerHeader title="Latest syncs from Data Sources" onClose={onClose} />
        <ListView.List
          data={logs}
          renderRow={item => (
            <ListRow gridTemplateColumns="30px 130px 1fr auto">
              <DataSourceIcon dataSource={item.datasource?.sourceType ?? "unknown"} />
              <Title>{formatDate(item.timestamp, DateFormats.datetime.long)}</Title>
              <CappedTitle
                showTooltip
                color={
                  item.status === "success"
                    ? theme.palette.success.default
                    : theme.palette.danger.default
                }
              >
                {item.message}
              </CappedTitle>
              <Icon
                name={item.status === "success" ? "checkCircle" : "crossCircle"}
                color={
                  item.status === "success"
                    ? theme.palette.success.default
                    : theme.palette.danger.default
                }
              />
            </ListRow>
          )}
        ></ListView.List>
      </Stack>
    </Drawer>
  );
};
